module.exports = __webpack_public_path__ + "static/img/s_2@2x.d43ee6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/s_2@2x.png
// module id = gs7+
// module chunks = 2